// removed by extract-text-webpack-plugin
module.exports = {"about":"src-pages----index-module---about---2YX_B","avatar":"src-pages----index-module---avatar---1N6Fh","excerpt":"src-pages----index-module---excerpt---2AAw_","ribbon":"src-pages----index-module---ribbon---1Onha","description":"src-pages----index-module---description---2V8fA"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/index.module.css
// module id = 386
// module chunks = 35783957827783